import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search } = useLocation();

  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  const queryMap: Record<string, string | undefined> = {};
  queryParams.forEach((value, key) => (queryMap[key] = value));

  return { queryParams, queryMap };
};
